module.exports = __webpack_public_path__ + "static/img/logo.33a9bcfd.png";